import React, { useState, useContext, useEffect, useRef } from 'react';
import 'twin.macro';
import { Comment } from '.';
import { Button } from '../button';
import { LoadingDots } from '../loading';
import { useInView } from '../common/hooks';
import { CommentsContext } from '../context/';

export const InfiniteScrollCommentsList = ({ itemsPerPage }) => {
  const { commentsList } = useContext(CommentsContext);

  const [visibleItems, setVisibleItems] = useState(itemsPerPage);
  const [loading, setLoading] = useState(false);
  const loadRef = useRef(null);
  const [ref, isInView] = useInView(loadRef, { threshold: 0.5 });

  const addMoreComments = () => {
    setLoading(true);
    setVisibleItems(visibleItems + itemsPerPage);
    setLoading(false);
  };

  useEffect(() => {
    if (isInView && !loading) {
      addMoreComments();
    }
  }, [isInView, loading]);

  useEffect(() => {
    if (itemsPerPage === 999) setVisibleItems(999);
  }, [itemsPerPage]);

  return (
    <>
      {commentsList !== null &&
        commentsList
          .slice(0, visibleItems)
          .map((comment) => <Comment key={comment.id} comment={comment} />)}
      {loading && <LoadingDots />}
      {visibleItems < commentsList.length && visibleItems !== -1 && !loading && (
        <div tw='w-full my-1' ref={ref} onClick={() => addMoreComments()}>
          <Button label='klik voor meer comments' tw='w-max mx-auto' ghost />
        </div>
      )}
    </>
  );
};
